import { calcSpeedDrops } from "@components/Charts/ChartUtils";
import CleanChart from "@components/Charts/CleanChart";
import { ALGOS_E } from "@constants/Algos";
import { useIntl } from "react-intl";
import { VISIBILITY_TIMEOUT_MS } from "../../../../../config";
import useMinerChartControl from "./MinerChart.control";
import "./MinerChart.scss";
import { Select } from "@components/global/new/Select/Select";

interface IMinerChartProps {
  minerId: number;
  defaultSpeed?: number;
  speedDropsPercent?: number;
  currentSpeed?: number;
  poolHash?: ALGOS_E;
  className?: string;
  chartClassName?: string;

  currentRejected: number;
  currentAccepted: number;
  currentState: number;
  minerMinerId?: string;
}

function MinerChart({
  minerId,
  defaultSpeed,
  speedDropsPercent,
  currentSpeed,
  poolHash,
  chartClassName,

  currentAccepted,
  currentRejected,
  currentState,
  minerMinerId,
}: IMinerChartProps): JSX.Element {

  const { formatMessage } = useIntl();
  const control = useMinerChartControl({
    minerId,
    currentSpeed,
    currentRejected,
    currentAccepted,
    currentState
  });

  return (
    <>
      <CleanChart
        id={minerId}
        tag={minerMinerId}
        scale={control.scale}
        showLegend={true}
        showY1Scales={true}
        defaultSpeed={defaultSpeed}
        speedDrops={calcSpeedDrops(speedDropsPercent, defaultSpeed)}
        poolHash={poolHash}
        periodControl={control.periodControl}
        datasets={control.datasets}
        liveDataSource={control.liveDataSource}
        isLoading={control.isLoading}
        visibilityTimeoutMs={VISIBILITY_TIMEOUT_MS}
        onVisible={control.refresh}
        chartClassName={chartClassName}
        showExport={true}
      >
        <>
          <div className='chart_scale'>
            <label>{formatMessage({ id: "chart.scale" })}</label>
            <Select
              style={{
                width: 70,
                height: 29,
              }}
              showSearch={false}
              options={control.scales}
              onChange={control.setScale}
              defaultValue={control.scale}
            />
          </div>
        </>
      </CleanChart>
    </>
  );
}
export default MinerChart;
